import { useTranslation } from 'react-i18next';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ListeRegistre } from '../registre-police/ListeRegistre.js';
import styles from '../registre-police/RegistrePolice.module.css';

export function ArchiveRegistrePolicePage() {
  const { t } = useTranslation('regie');
  const { galerieSlug, galerie } = useShellContext();
  return (
    <section className={styles.page} data-ui="page">
      <header data-ui="page-heading">
        <h1>{t('registrePolice.archiveTitre')}</h1>
        <p>{t('registrePolice.lectureSeule')}</p>
      </header>
      <ListeRegistre
        galerieSlug={galerieSlug}
        archive
        peutLire={galerieALaction(galerie, 'registre-police:read')}
      />
    </section>
  );
}
